module.exports = __webpack_public_path__ + "static/img/sand_15_mini2.35584419.png";